
import { Component, Vue, Prop } from "vue-property-decorator"
import RichTextEditorPlaceholder from "@/types/RichTextEditorPlaceholder";

@Component({})
export default class SearchDropDown extends Vue {
	@Prop({ type: Array, default: () => [] })
	options!: any[]

	@Prop({ type: String, default: "label" })
	label!: string

	@Prop({ type: String, default: "" })
	text!: string

	@Prop({ type: String, default: "md" })
	size!: "sm" | "md" | "lg"

	@Prop({ type: Boolean, default: false })
	right!: boolean

	@Prop({ type: Boolean, default: false })
	canCreateOption!: boolean;

	// Optional colour indicator rendered as a small circle inside the toggle button, right of the text.
	@Prop({ type: String, default: "" })
	dotColor!: string;

	@Prop({ type: Boolean, default: false })
	canDeleteOption!: boolean;

	@Prop({ type: String, default: "option" })
	term!: string;

	// Greys out and blocks the toggle, so a read-only form can render the picker inert rather than
	// hiding it. Without this the attribute would fall through onto the root element and do nothing.
	@Prop({ type: Boolean, default: false })
	disabled!: boolean;

	private searchTerm: string = ""

	get filteredItems(): any[] {
		const lowerSearch = this.searchTerm.toLowerCase()
		return this.options.filter(o => (o[this.label] as string).toLowerCase().includes(lowerSearch))
	}

	private onAddNewItem(): void {
		this.$emit("addNewItem", this.searchTerm);
		this.searchTerm = "";
	}

	private onDeleteItem(item: RichTextEditorPlaceholder): void {
		const ix = this.options.findIndex(o => o.id === item.id);
		if(ix > -1) {
			this.options.splice(ix, 1);
			this.$emit("deleteItem", item);
		}
	}
}
